import { useState } from "react";
import PersonIcon from "@mui/icons-material/Person";
import BusinessIcon from "@mui/icons-material/Business";
import CallIcon from "@mui/icons-material/Call";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import DateRangeIcon from "@mui/icons-material/DateRange";
import ScheduleIcon from "@mui/icons-material/Schedule";
import BadgeIcon from "@mui/icons-material/Badge";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import { STATUS_CODE_MAP } from "../../../constants/provider/constant";
import ActionsCell from "./actions-cell";

const NameTitles = ['mr', 'ms', 'mrs'];
function intersect(a, b) {
  var setB = new Set(b);
  return [...new Set(a)].filter(x => setB.has(x));
}

const CardAccordionInsurance = ({
  isSelected,
  // handleClick,
  row,
  redirectToHistory,
  index,
  // getPackageDetails,
  // getReports,
  status,
  pageName,
  handleClickOpencustomerAttendance,
  handleClickOpenShowCommunicationHistory,
  handleClickOpenConfirmAppointment,
  handleClickOpendocumentSubmission
}) => {
  const [isVisible, setIsVisible] = useState(false);
  // const isItemSelected = isSelected(row.rowData);
  // const labelId = `enhanced-table-checkbox-${index}`;
  const {
    rowData,
    requestid,
    customername,
    visitType,
    packagedetails,
    appointmentdatetime,
    appointmentdate,
    contactNo,
    corporatename,
    employeeId,
    isHNI,
    breachTime,
    employeeMailID,
    createdDateTime
  } = row;
  const { additionalInformation: {addressLine1, addressLine2, additionals: { DNDCustomer, DND } = {}} = {} } = {...rowData};
  // const { addressLine1, addressLine2, additionals } =
  //   additionalInformation;
  // const { DNDCustomer, DND } = additionals;
  let customerAddress = "";
  if (visitType === "Home_Visit" && (addressLine1 || addressLine2)) {
    if (addressLine1.includes(addressLine2)) customerAddress = addressLine1;
    else customerAddress = `${addressLine1}, ${addressLine2}`;
  }
  let dndStatus = "";
  if (DNDCustomer) dndStatus = DNDCustomer;
  else if (DND) dndStatus = DND;
  let shortName = customername?.split(' ');
  if(shortName?.length && intersect(shortName, NameTitles)?.length) {
    shortName = `${shortName[1]} ${shortName[2] ? shortName[2][0] : ''}`;
  } else {
    shortName = `${shortName[0]} ${shortName[1] ? shortName[1][0] : ''}`;
  }
  return (
    <>
      <div className="appointment-card-wrapper pd-xs-15">
        <div
          role="button"
          onClick={(evt) => {
            evt.stopPropagation();
            setIsVisible((val) => !val);
          }}
          className="card-first-row flex js-sp-bt-xs al-itm-ctr"
        >
          {/* <div>
            <Checkbox
              className="pd-xs-0 "
              color="primary"
              onClick={(event) => {
                event.stopPropagation();
                handleClick(event, row.rowData);
              }}
              checked={isItemSelected}
              disabled={
                (row.rowData.currentStatusId !== STATUS_CODE_MAP["Not Attended"]
                  ? false
                  : true) ||
                (row.rowData.currentStatusId !==
                  STATUS_CODE_MAP["Customer awaited at DC"] &&
                  pageName?.length && pageName.includes(status))
              }
              inputProps={{
                "aria-labelledby": labelId,
              }}
            />
          </div> */}
          <div
            onClick={(event) => {
              event.stopPropagation();
              redirectToHistory(event, row.requestid);
            }}
            className="text-blue-600 font-semibold cursor-pointer"
          >
            Req Id: <b>{requestid}</b>
          </div>
          <div>
            <PersonIcon /> <b>{shortName ? shortName : customername}</b>
          </div>
          <div className="text-gray-500 text-xs" role="button" onClick={(evt) => evt.stopPropagation()}>
            <CallIcon /> <a href={`tel:${contactNo}`}>{contactNo}</a>
          </div>
          <div>
            {isVisible ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </div>
        </div>

        {isVisible ? (
          <div className="card-accordion-row">
            <div className="flex js-sp-bt-xs pd-tp-xs-5">
              {customerAddress ? (
                <div className="flex al-itm-ctr address-customer">
                  <HomeWorkIcon />
                  <b>{customerAddress}</b>
                </div>
              ) : (
                <></>
              )}
            </div>
            <div className="flex js-sp-bt-xs pd-tp-xs-5 text-blue-600">
              <div className="flex al-itm-ctr">
                <MedicalServicesIcon />
                <button
                  // onClick={() =>
                  //   getPackageDetails(
                  //     OrderItemProductIds
                  //       ? OrderItemProductIds
                  //       : String(orderItemProductId),
                  //     packagedetails
                  //   )
                  // }
                >
                  {packagedetails}
                </button>
              </div>
            </div>
            <div className="flex js-sp-bt-xs pd-tp-xs-5">
              <div>
                <DateRangeIcon />
                {appointmentdate}
              </div>
              <div>
                <ScheduleIcon />
                {appointmentdatetime}
              </div>
              {/* {[MBContract["ESALES"], MBContract["PrePolicy"]].includes(
                requestContractType
              ) && (
                <Tooltip title="Document Download" placement="bottom-end">
                  <GetAppRoundedIcon
                    className="text-gray-500 mx-1 text-yellow-700 cursor-pointer"
                    onClick={() => {
                      getReports(additionalInformation);
                    }}
                  />
                </Tooltip>
              )} */}
            </div>
            <div className="flex js-sp-bt-xs pd-tp-xs-5">
              <div>
                <DateRangeIcon />
                {appointmentdate}
              </div>
              <div>
                <ScheduleIcon className="text-blue-600" />
                {createdDateTime}
              </div>
            </div>
            <div className="flex js-sp-bt-xs pd-tp-xs-5">
              <div className="flex al-itm-ctr  pd-rt-xs-5">
                <BusinessIcon /> {corporatename}
              </div>
            </div>
            <div className="flex js-sp-bt-xs pd-tp-xs-5">
              <div className="flex al-itm-ctr  pd-rt-xs-5">
                <PermIdentityIcon /> {employeeMailID}
              </div>
            </div>
            <div className="flex js-sp-bt-xs pd-tp-xs-5">
              <div className="flex al-itm-ctr">
                <BadgeIcon />
                {employeeId}
              </div>
              {
                ["pending","received"].includes(status) &&
                <div className="flex al-itm-ctr">
                    {
                      row.appointmentdetails && [STATUS_CODE_MAP["Info submitted"], STATUS_CODE_MAP["Digitization Pending"], STATUS_CODE_MAP["Information Awaited"]].includes(row.rowData.currentStatusId) &&
                      <div className={(row.rowData.currentStatusId === STATUS_CODE_MAP["Information Awaited"]) ? "bg-red-300 text-gray-900 rounded p-2 text-center w-auto text-xs font-semibold" : "bg-gray-300 text-gray-900 rounded p-2 text-center w-auto text-xs font-semibold"}>
                        {
                        [STATUS_CODE_MAP["Info submitted"], STATUS_CODE_MAP["Digitization Pending"], STATUS_CODE_MAP["Branch Approval Pending"]].includes(row.rowData.currentStatusId) && status === "received" &&  "QC Pending"
                        }
                        {
                          row.rowData.currentStatusId === STATUS_CODE_MAP["Information Awaited"] && status ==="pending" && "QC Rejected" 
                        }
                      </div>
                    }  
                    {
                    row.rowData && row.rowData.remarks && row.rowData.currentStatusId === 33 &&
                        <div className={(row.appointmentdetails ? "text-xxs py-1 text-gray-500" : "text-xs py-1 text-gray-500")}>
                          <span> {row.rowData.remarks} </span>
                        </div> 
                    }
                  
                </div>
              }
            </div>
          </div>
        ) : (
          <></>
        )}
        <div className="flex js-sp-bt-x pd-tp-xs-15 al-itm-strt">
          <ActionsCell
            visitType={visitType}
            dndStatus={dndStatus}
            isHNI={isHNI}
            status={status}
            row={row}
            pageName={pageName}
            handleClickOpencustomerAttendance={
              handleClickOpencustomerAttendance
            }
            handleClickOpenShowCommunicationHistory={
              handleClickOpenShowCommunicationHistory
            }
            handleClickOpenConfirmAppointment={
              handleClickOpenConfirmAppointment
            }
            handleClickOpendocumentSubmission={handleClickOpendocumentSubmission}
          />
          {
            breachTime &&
              <div className='pt-1 text-center w-full font-normal mt-1 bg-red-100 rounded action-msg' style={{fontSize:"12px"}}>
                  <div className='animateSLACount'>
                    <PendingActionsIcon/>
                    {
                      breachTime?.month ? 
                          <span>{breachTime?.month} Month</span> 
                      : breachTime?.day ? 
                          <span>{breachTime?.day} Day{breachTime?.hour?`s ${breachTime?.hour} Hours`:""}</span> 
                      : breachTime?.hour ? 
                          <span>{breachTime?.hour} Hour</span>
                      :""
                    }
                  </div>
              </div>
          }
        </div>
      </div>
    </>
  );
};

export default CardAccordionInsurance;
